import { dateFns, dateTimeFns, Iso } from 'iso-fns2'

export function getBillableDaysInRange(start: Iso.DateTime, end: Iso.DateTime): Iso.Date[] {
  const startDate = dateTimeFns.toDate(start)

  const hours = dateTimeFns
    .chain(start)
    .until(end, { largestUnit: 'hour', smallestUnit: 'hour', roundingMode: 'floor' })
    .getHours()
    .value()
  const duration = Math.max(Math.ceil(hours / 24), 1)

  const billableDays: Iso.Date[] = []
  for (let i = 0; i < duration; i++) {
    billableDays.push(dateFns.add(startDate, { days: i }))
  }

  return billableDays
}
